import api from './index';

export const authApi = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  me: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Register OneSignal userId for push notifications
  registerOneSignalUserId: async (onesignalUserId) => {
    try {
      const response = await api.post('/auth/onesignal/register', { 
        onesignal_user_id: onesignalUserId 
      });
      console.log('OneSignal register response:', response.data);
      
      // Handle different response formats
      if (response.data && typeof response.data === 'object') {
        // If response has message or session, it's successful
        if (response.data.message || response.data.session) {
          return { success: true, ...response.data };
        }
        // If it has success property, use it
        if (response.data.success !== undefined) {
          return response.data;
        }
        // Otherwise assume success
        return { success: true, ...response.data };
      }
      // If response is just success message, return it
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error registering OneSignal userId:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      // Don't throw error, just log it - notifications are optional
      return { 
        success: false, 
        error: error.response?.data?.message || error.message || 'Unknown error' 
      };
    }
  },

  // Unregister OneSignal userId for push notifications
  unregisterOneSignalUserId: async (onesignalUserId) => {
    try {
      const response = await api.post('/auth/onesignal/unregister', { 
        onesignal_user_id: onesignalUserId 
      });
      return response.data;
    } catch (error) {
      console.error('Error unregistering OneSignal userId:', error);
      // Don't throw error, just log it - notifications are optional
      return { success: false, error: error.message };
    }
  },

  logout: () => {
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('user');
  },
};

